module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f31a.5828a9ab.svg";